export function formatNumber(money) {
  return parseInt(money).toLocaleString('ko-KR')
}
